import React from 'react';
import PropTypes from 'prop-types';
import styles from './TaskCard.module.css';

/**
 * Card component for task search results
 * Using React.memo to prevent unnecessary re-renders
 */
const TaskCard = React.memo(({ task, searchTerm }) => {
	return (
		<div className={styles.taskCard}>
			<div className={styles.cardHeader}>
				<h4 className={styles.taskName}>{task.name}</h4>
			</div>
			
			<div className={styles.cardBody}>
				<div className={styles.tagsSection}>
					<span className={styles.sectionLabel}>Tags:</span>
					<div className={styles.tagsContainer}>
						{task.tags &&
							task.tags.map((tag, tagIndex) => {
								const isHighlighted =
									searchTerm &&
									tag.toLowerCase().includes(searchTerm.toLowerCase());

								return (
									<span
										key={tagIndex}
										className={`${styles.tag} ${
											isHighlighted ? styles.highlightedTag : ''
										}`}>
										{tag}
									</span>
								);
							})}
					</div>
				</div>
			</div>

			<div className={styles.cardFooter}>
				{task.teamwork ? (
					<a
						href={task.teamwork}
						target='_blank'
						rel='noopener noreferrer'
						className={styles.teamworkLink}
						aria-label={`Open task ${task.name} in Teamwork`}>
						<span className={styles.viewButton}>View in Teamwork</span>
					</a>
				) : (
					<span className={styles.noLink}>No link available</span>
				)}
			</div>
		</div>
	);
});

// Define prop types for better documentation and runtime type checking
TaskCard.propTypes = {
	task: PropTypes.shape({
		id: PropTypes.string,
		name: PropTypes.string.isRequired,
		tags: PropTypes.arrayOf(PropTypes.string),
		teamwork: PropTypes.string,
	}).isRequired,
	searchTerm: PropTypes.string,
};

// Display name for easier debugging in React DevTools
TaskCard.displayName = 'TaskCard';

export default TaskCard;